import React from 'react';
import Grid from '@mui/material/Grid';
import { Button, Container, styled } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DefaultTheme } from '@mui/styles';

const useStyles = makeStyles((theme: DefaultTheme) => ({
  decline__button: {
    padding: '14px 16px',
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: '32px !important',
    },
  },
}));

const Banner = styled(Grid)(({ theme }) => ({
  paddingTop: '56px',
  paddingBottom: '56px',
  top: 'auto',
  bottom: 0,
  position: 'fixed',
  zIndex: 2000,
  backgroundColor: theme.palette.neutral.light,
  color: theme.palette.black.main,
  boxShadow: '0 -3px 4px -1px rgba(0, 0, 0, 0.2), 0 -1px 10px 0 rgba(0, 0, 0, 0.12), 0 -4px 5px 0 rgba(0, 0, 0, 0.14)',
  minHeight: '300px',
  [theme.breakpoints.up('sm')]: {
    minHeight: '200px',
  },
}));

const BannerContainer = styled(Grid)(() => ({
  paddingLeft: '32px',
  paddingRight: '32px',
  height: '100%',
}));

const BannerText = styled(Grid)(({ theme }) => `
font-family: 'Lato';
font-size: 1rem;
 & p {
   margin: 0;
 }

 & a, a:visited, a:hover, a:active {
   color: ${theme.palette.primary.main};
   text-decoration: underline;
   font-weight: 600;
 }
`);

const BannerButton = styled(Button)(() => ({
  fontWeight: 600,
}));

const BannerButtons = styled(Grid)(({ theme }) => ({
  marginTop: '56px',
  [theme.breakpoints.up('md')]: {
    marginTop: 0,
  },
}));

interface CookieBannerProps {

  onAccept: () => void;
  onDecline: () => void;
  acceptLabel: string;
  declineLabel: string;
  children: JSX.Element | JSX.Element[]

}

const CookieBanner: React.FC<CookieBannerProps> = (props: CookieBannerProps) => {
  const classes = useStyles();

  return (
    <Banner container direction="row" justifyContent="center">
      <Container>
        <BannerContainer item container direction="row" justifyContent="center" alignItems="center">
          <BannerText item xs={12} md={8} lg={7}>
            {
                props.children
            }
          </BannerText>
          <BannerButtons item container justifyContent="flex-end" xs={12} md={4} lg={5}>
            <BannerButton
              className={classes.decline__button}
              onClick={props.onDecline}
              color="primary"
            >
              {props.declineLabel}
            </BannerButton>

            <BannerButton
              variant="contained"
              color="primary"
              onClick={props.onAccept}
            >
              {props.acceptLabel}
            </BannerButton>
          </BannerButtons>
        </BannerContainer>
      </Container>
    </Banner>
  );
};

export default CookieBanner;
